import API from "serviceshift-ui/api-client";

export default {
  uploadCoverageAreas(_, { file }) {
    const formData = new FormData();
    formData.append("file", file);
    return API.makeRequest(`/admin/v4/coverage_areas/import`, {
      method: "POST",
      data: formData
    });
  },
  createCoverageArea(_, { coverage_area }) {
    return API.makeRequest("/admin/v4/coverage_areas", {
      method: "POST",
      data: { coverage_area }
    });
  },
  updateCoverageArea(_, { coverage_area }) {
    return API.makeRequest(`/admin/v4/coverage_areas/${coverage_area.id}`, {
      method: "PUT",
      data: { coverage_area }
    });
  },
  deleteCoverageArea(_, id) {
    return API.makeRequest(`/admin/v4/coverage_areas/${id}`, {
      method: "DELETE"
    });
  }
};
